import React, { useState } from "react";
import {
  Row,
  Col,
  Button,
  Form,
  Input,
  Card,
  Modal,
  Divider,
  Typography,
  message,
} from "antd";
import { Link, useNavigate } from "react-router-dom";
import "./Login.css";
import { loginUser } from "../../../services/userDataService";
import { useDispatch, useSelector } from "react-redux";
import { loginBegin, loginSuccess } from "../../../state/reducers/loginSlice";
import { setAuthentication } from "../../../state/reducers/userSlice";
import { jwtDecode } from "jwt-decode";

const { Text } = Typography;

const Login = () => {
  const token = useSelector((state) => state.user.token);
  // const newPassword = useSelector((state) => state.user.newPassword); // Fetch newPassword from Redux
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [forgotPasswordVisible, setForgotPasswordVisible] = useState(false);
  const [form] = Form.useForm();

  const showForgotPasswordModal = () => {
    setForgotPasswordVisible(true);
  };

  const closeForgotPasswordModal = () => {
    setForgotPasswordVisible(false);
  };

  const handleSubmit = async (values) => {
    try {
      dispatch(loginBegin());
      const res = await loginUser(values, token);
      localStorage.setItem("token", res.data.data);
      dispatch(setAuthentication(res.data.data));
      dispatch(loginSuccess());
      message.success("Login successful");
      const decodedToken = await jwtDecode(res.data.data);
      const newPassword = decodedToken.newPassword; // Assuming newPassword is in the token payload

      // Check if user needs to set a new password
      if (newPassword) {
        navigate("/", { state: { requiresPasswordChange: true } });
      } else {
        navigate("/"); // If not, proceed with navigation
      }
    } catch (err) {
      message.error(err.response.data.message);
    }
  };

  return (
    <>
      <Typography.Title level={2} style={{ textAlign: "center" }}>
        User login
      </Typography.Title>
      <Row style={{ margin: "1rem" }}>
        <Col
          xs={{ span: 24, offset: 0 }}
          sm={{ span: 14, offset: 6 }}
          md={{ span: 12, offset: 6 }}
          lg={{ span: 8, offset: 8 }}
          xl={{ span: 8, offset: 8 }}
        >
          <Card>
            <Form
              form={form}
              layout="vertical"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 24 }}
              initialValues={{ remember: true }}
              onFinish={handleSubmit}
            >
              <Form.Item
                label="Email"
                name="email"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Password"
                name="password"
                rules={[{ required: true }]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Login
                </Button>
              </Form.Item>
            </Form>
            <Divider />
            <Text>
              Don't have an account? <Link to={"/contact"}>Contact Us</Link>
            </Text>
            <Text
              style={{ whiteSpace: "nowrap" }}
              onClick={showForgotPasswordModal}
            >
              Don't remember your password?
            </Text>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Login;
